import useSWR from 'swr';

import type {
  CustomerOverview,
  CustomerLevelOverview,
  CustomerOverviewResponse,
  CustomerType,
} from '@repo/types/customer-overview';

export function useCustomerOverview(shouldFetch: boolean = true) {
  return useSWR(
    shouldFetch ? '/protected/api/loyalty-management/memberships/customer/overview' : null,
    async (...args): Promise<CustomerOverview> => {
      const response = await fetch(...args);

      const data = (await response.json()) as CustomerOverviewResponse;

      return {
        ...data,
        customerType: getCustomerType(data.customerInfo.loyaltyLevel),
      };
    },
    {
      errorRetryInterval: 1000,
      errorRetryCount: 3,
      dedupingInterval: 5000,
      revalidateOnFocus: false,
    },
  );
}

export function getCustomerType(customerLevel: CustomerLevelOverview): CustomerType {
  if (
    customerLevel.status === 'DELETED' ||
    customerLevel.status === 'CANCELLED' ||
    customerLevel.status === 'EXPIRED'
  ) {
    return 'basic';
  }

  if (Array.isArray(customerLevel.tags)) {
    if (customerLevel.tags.includes('PREMIUM') || customerLevel.tags.includes('SAVINGS_PLAN')) {
      return 'premium';
    }
  }

  // fallback to check customer level type if tags are not available
  if (customerLevel.type === 'PREMIUM' || customerLevel.type === 'SP_MIGRATION') {
    return 'premium';
  }

  return 'basic';
}
